import React from "react";
import {Button} from "../../../buttons";
import {t} from "i18next";

import downIcon from "../../../../assets/images/moveLayerDown.svg";

const SetProductsByXlsx: React.FC = () => {
    return (
        <Button
            appearance="primary"
            clickHandler={(e) => console.log(e)}
        >
            <div className="flex justify-around items-center">
                <img src={downIcon} className="w-4 h-4 mr-2 rotate-180" />
                <span>{t<string>("Установить товары", {ns: "messages"})}</span>
            </div>
        </Button>
    )
}

export default SetProductsByXlsx;